// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fill[data-v-0e7fe6c8]{fill:#77a2ff}.fill.active[data-v-0e7fe6c8]{fill:#e0fd78}", "",{"version":3,"sources":["webpack://./assets/js/vue/plan.vue"],"names":[],"mappings":"AACA,uBACI,YAAJ,CAEI,8BACI,YAAR","sourcesContent":["\r\n.fill {\r\n    fill: #77a2ff;\r\n\r\n    &.active {\r\n        fill: #E0FD78;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
